
<div class="column">
    <nova-locums-recruiter-board-certs *ngIf="isLocumsPhysicianProfession$ | async" [jobId]="jobId"></nova-locums-recruiter-board-certs>
    <nova-locums-recruiter-crna-cert *ngIf="isCRNA$ | async"></nova-locums-recruiter-crna-cert>
    <nova-locums-recruiter-state-licenses [jobId]="jobId"></nova-locums-recruiter-state-licenses>
    <nova-locums-recruiter-will-license [jobId]="jobId"></nova-locums-recruiter-will-license>
    <nova-locums-recruiter-certifications [jobId]="jobId"></nova-locums-recruiter-certifications>
    <nova-locums-recruiter-dea [jobId]="jobId"></nova-locums-recruiter-dea>
    <nova-locums-recruiter-controlled-substances [jobId]="jobId"></nova-locums-recruiter-controlled-substances>
    <nova-locums-recruiter-experience [jobId]="jobId"></nova-locums-recruiter-experience>
</div>
